import { Typography } from '@mui/material'
import React from 'react'
import { SupportedTicker, TICKERS_MAP_BY_NAME } from '@/constants/token'
import { formatNumber } from '@/utils'
import { CHAIN_INFO } from '@/constants'

const BridgeFeeCell = ({
  tickerName,
  chainId,
  amount,
}: {
  tickerName: SupportedTicker
  chainId: number
  amount: string
}) => {
  const isOnBtc = chainId === 0

  const decimal = isOnBtc ? 18 : CHAIN_INFO[chainId].nativeCurrency.decimals

  const feeTokenName = isOnBtc ? tickerName : CHAIN_INFO[chainId].nativeCurrency.symbol

  return (
    <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>
      {formatNumber(amount, decimal, { decimal: 6 })} {feeTokenName}
    </Typography>
  )
}

export default BridgeFeeCell
